import CryptoJS from "crypto-js";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";

export const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const getUserData = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("userData"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
};

export const getPerPageRecords = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("GLOBAL_SETTING"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    const data = JSON.parse(decryptedData);
    return data?.PER_PAGE_RECORDS || null;
    // const foundObject = data.find((obj) => obj.name === "PER_PAGE_RECORDS");
    // return foundObject ? foundObject : null;
};

export const getPlatformFee = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("GLOBAL_SETTING"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    const data = JSON.parse(decryptedData);
    return data?.PLATFORM_FEES || null;
};

export const getLogoutOtpTime = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("GLOBAL_SETTING"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    const data = JSON.parse(decryptedData);
    return data?.LOGOUT_TIME_IN_MINUTE || null;
};

export const getPermissionData = (key) => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem(key),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
};

export const SuperAdminRoleId = 1;
export const adminRoleId = 2;
